import _ from 'lodash'

/**
Returns whether or not to show a stock level alert.

@param {object} medication. A medication object. Will
contain the latest stock log.
*/

export const getShowStockAlert = (medication: any) => {
  const { stockAlertLevel, stockLog } = medication

  const actualStock = stockLog && stockLog.amount1
  const expectedStock = stockLog && stockLog.amount2

  const showAlert = (actualStock || expectedStock) <= stockAlertLevel

  return showAlert
}

/**
Returns text for stock

@param {object} medication. A medication object. Will
contain the latest stock log.
*/

export const getStockText = (medication: any) => {
  const { quantityType, stockQuantityType, stockLog } = medication
  if (!stockLog) return undefined
  const actualStock = stockLog.amount1
  const expectedStock = stockLog.amount2

  const unit = stockQuantityType || quantityType || null
  const hasActualStock = _.isNumber(actualStock)
  const stockCount = hasActualStock ? actualStock : expectedStock
  if (stockCount === 0) return 'Out of stock'
  return `${stockCount} ${unit ? `${unit} ` : ' '}left`
}
